export const FORM_FIELDS = {
  NON_ELIGIBLE_EMAIL: 'nonEligibleEmail',
} as const;
